// VW FONTSIZE
(function () {
    const root = document.documentElement;
    const MIN_VW = 32;   // floor for narrow phones
    const MAX_VW = 192;  // ceiling for ultrawide

    function coSetResponsiveFontSize() {
        const width = window.visualViewport?.width ?? window.innerWidth;
        const vw = Math.min(MAX_VW, Math.max(MIN_VW, width / 10));
        root.style.setProperty('--co-vw-font-size', `${vw}px`);
    }

    let rafId = null;
    function coScheduleUpdate() {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
            coSetResponsiveFontSize();
            rafId = null;
        });
    }

    coSetResponsiveFontSize();
    window.addEventListener('resize', coScheduleUpdate);
    window.addEventListener('orientationchange', coScheduleUpdate);
    window.addEventListener('pageshow', coScheduleUpdate); // bfcache
    window.visualViewport?.addEventListener('resize', coScheduleUpdate);
})();
//X VW FONTSIZE
// IMAGE LOADER
const coImagesGlobalLoader = document.querySelectorAll('img.co-img-loader');
coImagesGlobalLoader.forEach((img) => {
    const coHandleImageLoad = () => {
        img.classList.add("co-img-loaded");
    };
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});
//X IMAGE LOADER